module.exports = __webpack_public_path__ + "14b79bc1.png";